/** es/ca/it are deliberately the words `www/about-us.meta.ts` already serves — see slug-rewrites. */
export const routeName = 'about-us';
export const slugs: Record<string, string> = {
	es: 'sobre-nosotros',
	en: 'about-us',
	ca: 'sobre-nosaltres',
	fr: 'qui-sommes-nous',
	it: 'chi-siamo',
};
export const sitemap = { changefreq: 'monthly', priority: '0.8', lastmod: '2026-08-21' };
